import { Container } from '@material-ui/core';
import ProviderSearch from '../components/settings/ProviderSearch';
import Page from '../components/Page';

export default function Provider() {
  return (
    <Page title="Dashboard: Client | ZIMTA">
      <Container>
        <ProviderSearch />
      </Container>
    </Page>
  );
}
